import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { authService } from '../services/api';
import Toast from './Toast';

/**
 * AuthGuard component to provide centralized handling of authentication
 * and unauthorized redirect behavior
 */
const AuthGuard = ({ children }) => {
  const navigate = useNavigate();
  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState('');

  useEffect(() => {
    // Check if user is authenticated
    const isAuthenticated = authService.isAuthenticated();
    if (!isAuthenticated) {
      navigate('/login');
      return;
    }

    // Listen for unauthorized access events
    const handleUnauthorizedAccess = () => {
      console.log('Unauthorized access detected by AuthGuard');
      setToastMessage('Your session has expired. Please log in again.');
      setShowToast(true);
      // Give the user a moment to see the message before redirecting
      setTimeout(() => {
        navigate('/login');
      }, 2500);
    };

    // Add event listener
    document.addEventListener('unauthorized-access', handleUnauthorizedAccess);

    // Cleanup
    return () => {
      document.removeEventListener('unauthorized-access', handleUnauthorizedAccess);
    };
  }, [navigate]);

  const handleCloseToast = () => {
    setShowToast(false);
  };

  return (
    <>
      {children}
      <Toast 
        show={showToast}
        message={toastMessage}
        type="error"
        duration={3000}
        onClose={handleCloseToast}
      />
    </>
  );
};

export default AuthGuard; 